"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.StockMovementReducer = undefined;

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _apiStockMovement = require("../actions/esdb/apiStockMovement");

var _apiStockMovementCreate_post = require("../actions/esdb/apiStockMovementCreate_post");

var _apiStockMovementCancel_post = require("../actions/esdb/apiStockMovementCancel_post");

var _apiStockMovementMerge_post = require("../actions/esdb/apiStockMovementMerge_post");

var _apiStockMovementPosition_post = require("../actions/esdb/apiStockMovementPosition_post");

var _apiStockMovements = require("../actions/esdb/apiStockMovements");

var _apiStockMovementPartialPickAndCreateNew_post = require("../actions/esdb/apiStockMovementPartialPickAndCreateNew_post");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var StockMovementReducer = exports.StockMovementReducer = function StockMovementReducer() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	var action = arguments[1];

	var merged = void 0;
	var STOCK_MOVEMENTS = void 0;
	var DELETED_STOCK_MOVEMENTS = void 0;
	switch (action.type) {
		case _apiStockMovement.API_STOCK_MOVEMENT_REQUEST:
		case _apiStockMovementCancel_post.API_STOCK_MOVEMENT_CANCEL_POST_REQUEST:
			return _lodash2.default.merge({}, state, _defineProperty({}, action.options.STOCK_MOVEMENT_ID, {
				loading: true
			}));

		case _apiStockMovementPosition_post.API_STOCK_MOVEMENT_POSITION_POST_SUCCESS:
			STOCK_MOVEMENTS = _lodash2.default.get(action, ["payload", "data", "STOCK_MOVEMENTS"], []);
			merged = _lodash2.default.merge({}, state, STOCK_MOVEMENTS.reduce(function (obj, item) {
				obj[item.STOCK_MOVEMENT_ID] = {
					error: action.payload.error,
					data: item
				};
				return obj;
			}, {}));
			return merged;

		case _apiStockMovement.API_STOCK_MOVEMENT_SUCCESS:
		case _apiStockMovements.API_STOCK_MOVEMENTS_SUCCESS:
		case _apiStockMovementCreate_post.API_STOCK_MOVEMENT_CREATE_POST_SUCCESS:
		case _apiStockMovementCancel_post.API_STOCK_MOVEMENT_CANCEL_POST_SUCCESS:
		case _apiStockMovementMerge_post.API_STOCK_MOVEMENT_MERGE_POST_SUCCESS:
			STOCK_MOVEMENTS = _lodash2.default.get(action, ["payload", "data", "STOCK_MOVEMENTS"], []);
			merged = _lodash2.default.merge({}, state, STOCK_MOVEMENTS.reduce(function (obj, item) {
				obj[item.STOCK_MOVEMENT_ID] = {
					loading: action.payload.loading,
					error: action.payload.error,
					data: item
				};
				return obj;
			}, {}));
			DELETED_STOCK_MOVEMENTS = _lodash2.default.get(action, ["payload", "data", "DELETED_STOCK_MOVEMENTS"], []);
			DELETED_STOCK_MOVEMENTS.map(function (id) {
				return delete merged[id];
			});
			return merged;
		case _apiStockMovementPartialPickAndCreateNew_post.API_STOCK_MOVEMENT_PARTIAL_PICK_AND_CREATE_NEW_POST_SUCCESS:
			STOCK_MOVEMENTS = _lodash2.default.get(action, ["payload", "data", "STOCK_MOVEMENTS"], []);
			merged = Object.assign({}, state, STOCK_MOVEMENTS.reduce(function (obj, item) {
				obj[item.STOCK_MOVEMENT_ID] = {
					loading: action.payload.loading,
					error: action.payload.error,
					data: item
				};
				return obj;
			}, {}));
			DELETED_STOCK_MOVEMENTS = _lodash2.default.get(action, ["payload", "data", "DELETED_STOCK_MOVEMENTS"], []);
			DELETED_STOCK_MOVEMENTS.map(function (id) {
				return delete merged[id];
			});
			return merged;

		default:
			return state;
	}
};